import React from 'react';
import { Atom, FlaskConical, Dna, Calculator, ArrowRight, Star, Users } from 'lucide-react';

const Subjects = () => {
  const subjects = [
    {
      name: 'Physics',
      icon: Atom,
      color: 'blue',
      gradient: 'from-blue-500 to-cyan-500',
      image: 'https://images.unsplash.com/photo-1636466497217-26a8cbeaf0aa?w=400&h=300&fit=crop',
      tutorCount: 24,
      rating: 4.9
    },
    {
      name: 'Chemistry',
      icon: FlaskConical,
      color: 'green',
      gradient: 'from-green-500 to-emerald-500',
      image: 'https://images.unsplash.com/photo-1603126857599-f6e157fa2fe6?w=400&h=300&fit=crop',
      tutorCount: 18,
      rating: 4.8
    },
    {
      name: 'Biology',
      icon: Dna,
      color: 'teal',
      gradient: 'from-teal-500 to-green-500',
      image: 'https://images.unsplash.com/photo-1530026186672-2cd00ffc50fe?w=400&h=300&fit=crop',
      tutorCount: 22,
      rating: 4.9
    },
    {
      name: 'Mathematics',
      icon: Calculator,
      color: 'purple',
      gradient: 'from-purple-500 to-pink-500',
      image: 'https://images.unsplash.com/photo-1635070041078-e363dbe005cb?w=400&h=300&fit=crop',
      tutorCount: 31,
      rating: 4.9
    }
  ];

  return (
    <div className="py-16 px-4 bg-gray-50">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-800 mb-3">Subjects We Offer</h2>
          <p className="text-gray-500 max-w-md mx-auto">
            Learn from expert tutors specialized in each subject
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {subjects.map((subject) => (
            <div 
              key={subject.name}
              className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 group cursor-pointer"
            >
              <div className="relative h-40 overflow-hidden">
                <img 
                  src={subject.image} 
                  alt={subject.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className={`absolute inset-0 bg-gradient-to-t ${subject.gradient} opacity-60`}></div>
                <div className="absolute bottom-3 left-3 bg-white/90 backdrop-blur-sm rounded-lg p-2">
                  <subject.icon size={24} className={`text-${subject.color}-600`} />
                </div>
              </div>
              
              <div className="p-4">
                <div className="flex justify-between items-center mb-2">
                  <h3 className="text-xl font-bold text-gray-800">{subject.name}</h3>
                  <div className="flex items-center gap-1">
                    {/* <Star size={14} className="text-yellow-500 fill-yellow-500" />
                    <span className="text-sm font-semibold">{subject.rating}</span> */}
                  </div>
                </div>
                
                {/* <button className={`w-full py-2 rounded-lg font-medium transition-all flex items-center justify-center gap-2
                  bg-gradient-to-r ${subject.gradient} text-white hover:opacity-90`}>
                  Learn More
                  <ArrowRight size={16} />
                </button> */}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Subjects;